import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";

import { ProfileConstants } from "../constants/profile.constants";
import { LektoAuthService } from "../services/essential/lekto-auth.service";

import { OfflineModeStateService } from "./offline-mode-state.service";
import { isRouteAllowedOffline, OFFLINE_HOME_ROUTE } from "./offline-policy.util";

/**
 * DEV-966 (CA 05) — com o Modo Offline ligado, só Atribuições é alcançável. Qualquer outro
 * destino (Início, Biblioteca, Turmas, Minha Conta, Gerenciar, Avaliação) redireciona para
 * `/action`. Decide por ESTADO, não por rede: a pessoa pode estar com internet e ainda assim
 * ter escolhido consultar em modo isolado.
 *
 * DEV-1104: o modo não existe para o leitor (Aluno, Família) — as rotas dele no backend são só de quem
 * conduz turma, e o estado é guardado por app, não por perfil. Quem o ligou como Professor e trocou
 * para Família não fica preso em `/action`.
 */
export const offlineModeGuard: CanActivateFn & CanActivateChildFn = (
  _route,
  state: RouterStateSnapshot
) => {
  const offline = inject(OfflineModeStateService);
  if (!offline.enabled() || isRouteAllowedOffline(state.url)) return true;

  const profile = inject(LektoAuthService, { optional: true })?.authProfile() ?? "";
  if (ProfileConstants.isReaderProfile(profile)) return true;

  return inject(Router).createUrlTree([OFFLINE_HOME_ROUTE]);
};
